// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_atW","cls2":"DebugPage-cls2_o2W DebugPage-cls1_atW"};